import { useCallback, useEffect, useMemo, useState } from 'react'

import { useStoreActions, useStoreState } from 'easy-peasy'

import { BOX_PRODUCT_TYPE } from 'artkive/stores/product.constants'

function usePromo({ formType, productName = BOX_PRODUCT_TYPE }) {
  const state = useStoreState(({ promoStore }) => promoStore)
  const actions = useStoreActions(({ promoStore }) => promoStore)

  const [options, setOptions] = useState({ formType, product: productName })

  const dispatchPromo = useCallback(
    async (args = {}) => await actions.sendPromo({ ...options, ...args }),
    [actions, options],
  )

  useEffect(() => {
    setOptions({ formType, product: productName })
  }, [formType, productName])

  return useMemo(
    () => ({
      dispatchPromo,
      promoActions: { ...actions, dispatchPromo },
      promoState: state,
      promoCode: state.promo.code,
    }),
    [actions, dispatchPromo, state],
  )
}

export default usePromo
